export { CallToAction } from './callToAction'
export { default as callToActionFactory } from './callToActionFactory'
export type { CallToActionProps } from './callToAction'
